<h2>Global Company Prefix Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadBarcodeGlobalCompanyMappingGridDataSource">
    <div class="mapping-grid-container shadow-lg">
        <div class="flex">
            <button type="button" class="btn btn-light btn-create-product" (click)="createNewGlobalCompanyPrefixData()"><i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>
        <div class="mt-2 h-full">
            <dx-data-grid
                #barcodeGlobalCompanyPrefixMappingDataGrid
                id="barcodeGlobalCompanyPrefixMappingDataGrid"
                [allowColumnResizing]="true"
                [columnResizingMode]="'widget'"
                [allowColumnReordering]="true"
                [dataSource]="barcodeGlobalCompanyPrefixMappingDataSource"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [remoteOperations]="true"
                [hoverStateEnabled]="true"
                [(selectedRowKeys)]="barcodeGlobalCompanyPrefixMappingSelectedRowMap"
                (onSelectionChanged)="selectionMappingDataChangedHandler()"
                (onContentReady)="onReady($event)"
                (onContextMenuPreparing)="barcodeGlobalCompanyPrefixMappingDataGridContextMenu($event)"
                keyExpr="BarcodeGlobalCompanyPrefixMappingId"
            >
                <dxo-state-storing
                        [enabled]="true"
                        type="custom"
                        [customLoad]="loadMappingState"
                        [customSave]="saveMappingState">
                </dxo-state-storing>
                <dxo-load-panel
                        [enabled]="false"
                        shadingColor="rgba(0,0,0,0.4)"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true">
                </dxo-load-panel>
                <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="[5, 10, 25, 50, 100]"
                        displayMode="compact"
                        [showPageSizeSelector]="true"
                        [showNavigationButtons]="false"
                >
                </dxo-pager>
                <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

                <dxi-column dataField="BarcodeGlobalCompanyPrefixMappingId" [allowHeaderFiltering]="false" [width]="180" caption="Barcode Global Company Prefix Mapping Id"></dxi-column>
                <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>
                <dxi-column dataField="GlobalCompanyPrefix" caption="Global Company Prefix">
                    <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CompanyName" caption="Business Entity Name">
                    <dxo-header-filter [dataSource]="businessEntityNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false" [allowFiltering]="false">
                </dxi-column>
                <dxi-column dataField="MappingModeId" caption="Mapping Mode" [alignment]="'left'">
                    <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column caption="Mapped to">
                    <dxi-column dataField="BrandId" caption="Branding Level Id">
                        <dxo-header-filter [dataSource]="productBrandingLevelIdHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="BrandName" caption="Branding Level">
                        <dxo-header-filter [dataSource]="productBrandingLevelNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ProductMasterId" caption="Entity Id">
                        <dxo-header-filter [dataSource]="productMasterEntityIdNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CompanyName" caption="Company">
                        <dxo-header-filter [dataSource]="companyNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="MasterBrandName" caption="Master Brand">
                        <dxo-header-filter [dataSource]="masterBrandNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="BrandName" caption="Brand">
                        <dxo-header-filter [dataSource]="brandNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SubBrandName" caption="Sub-brand">
                        <dxo-header-filter [dataSource]="subBrandNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                </dxi-column>
                <dxi-column caption="Data auditing">
                    <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="true">
                        <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CreatedOn" caption="Create on" dataType="datetime" format="M/d/yyyy, HH:mm" [visible]="true" cssClass="hide-filter-icon">
                        <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by">
                        <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ModifiedOn" caption="Modified on" dataType="datetime" format="M/d/yyyy, HH:mm" [visible]="true" cssClass="hide-filter-icon">
                        <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="true">
                        <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ReviewedOn" caption="Reviewed on" dataType="datetime" format="M/d/yyyy, HH:mm" [visible]="true" cssClass="hide-filter-icon">
                        <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                </dxi-column>
                <dxi-column dataField="MappingModeKey" [visible]="false">
                </dxi-column>
                <dxi-column dataField="IsActive" caption="Is Active" [visible]="true"></dxi-column>


                <dxi-column dataField="Active" caption="Is Active" [visible]="false"></dxi-column>
                <div *dxTemplate="let action of 'action'">
                    <dx-button
                            class="mr-1"
                            hint="Clone"
                            icon="fas fa-clone fa-1x"
                            (onClick)="editGlobalCompanyPrefixData(action?.data, true)"></dx-button>
                    <dx-button
                            class="mr-1"
                            hint="Edit"
                            icon="fas fa-edit fa-1x"
                            (onClick)="editGlobalCompanyPrefixData(action?.data, false)"></dx-button>
                    <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.BarcodeGlobalCompanyPrefixMappingId)"></dx-button>
                    <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.BarcodeGlobalCompanyPrefixMappingId)"></dx-button>
                    <dx-button
                            id="btnAccept"
                            *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"
                            class="mr-1"
                            icon="fa fa-check fa-1x"
                            hint="Accept"
                            (onClick)="accept(action?.data?.BarcodeGlobalCompanyPrefixMappingId)"
                    ></dx-button>
                    <dx-button
                            id="btnReview"
                            *ngIf="action?.data?.modifiedByUserId > 0 && action?.data?.modifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                            icon="fas fa-check-double"
                            hint="Review"
                            (onClick)="review(action?.data?.BarcodeGlobalCompanyPrefixMappingId)"
                    ></dx-button>
                    <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.BarcodeGlobalCompanyPrefixMappingId)"></dx-button>
                    <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.BarcodeGlobalCompanyPrefixMappingId)"></dx-button>
                </div>
                <dxo-paging [pageSize]="5"></dxo-paging>
            </dx-data-grid>
        </div>
    </div>
</div>

<div class="py-3 block h-full" *ngIf="isLoadBarcodeGlobalCompanyMasterGridDataSource">
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #companyMasterDataGrid
            id="companyMasterDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="companyMasterDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="companyMasterSelectedRowMap"
            (onSelectionChanged)="selectionMasterDataChangedHandler()"
            (onContextMenuPreparing)="companyMasterDataGridContextMenu($event)"
            keyExpr="RowId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMasterState"
                    [customSave]="saveMasterState">
            </dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

            <dxi-column dataField="RowId" [allowHeaderFiltering]="false" [width]="140" caption="Branding Roster Id"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" [width]="90" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column dataField="ProductBrandingLevelName" caption="Branding Level">
                <dxo-header-filter [dataSource]="brandingLevelHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CompanyName" caption="Company">
                <dxo-header-filter [dataSource]="sourceCompanyHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MasterBrandName" caption="Master Brand">
                <dxo-header-filter [dataSource]="masterTableMasterBrandNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="BrandName" caption="Brand">
                <dxo-header-filter [dataSource]="masterTableBrandNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="SubBrandName" caption="Sub-brand">
                <dxo-header-filter [dataSource]="masterTableSubBrandNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>

            <div *dxTemplate="let action of 'action'">
                <dx-button
                        class="mr-1"
                        icon="fas fa-map-marker-alt fa-1x"
                        hint="Map"
                        (onClick)="map(action?.data?.CompanyId, action?.data?.ProductBrandingLevelId, action?.data?.ProductMasterEntityId)"
                ></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>
